import React, { Component } from 'react';
import styled from 'styled-components'
import { Button, Card, Divider, Input, Form, Select } from 'antd'
import { apiUtil as Util } from '../../mock/mockServices';

const { Option } = Select;

let params = new URLSearchParams(window.location.search);
let userId = params.get('id');

const formItemLayout = {
    labelCol: {
        span: 4
    },
    wrapperCol: {
        span: 20
    }
};

class UserMgrComponent extends Component {

    state = {
        orgId: '',
        id: userId,
        loginName: '',
        password: '',
        userName: '',
        mobile: '',
        remark: '',
        roleList: '',
        email: '',
        allOrgList: [],
        allRoleList: [],
        keyWordsOrg: '',
        sorterOrg: {},
        paginationOrg: {
            current: 1,
            pageSize: 9999,
            showTotal: total => `共${total}条 `,
            total: 0
        },
        keyWordsRole: '',
        sorterRole: {},
        paginationRole: {
            current: 1,
            pageSize: 9999,
            showTotal: total => `共${total}条 `,
            total: 0
        },
    }

    componentDidMount() {
        if (userId !== "0" && userId !== null && userId !== "null") {
            Util.ajax.get('/admin/getUserById', {
                id: userId
            }).then(res => {
                const { data } = res
                if (!data) {
                    return false
                }
                const { orgId, loginName, password, userName, mobile, email, remark, roleList } = data

                this.setState({
                    orgId: orgId ? orgId : '',
                    loginName: loginName ? loginName : '',
                    password: password ? password : '',
                    userName: userName ? userName : '',
                    mobile: mobile ? mobile : '',
                    email: email ? email : '',
                    remark: remark ? remark : '',
                    roleList: roleList ? roleList : '',
                })
            })
        }

        const { paginationOrg, keyWordsOrg } = this.state

        Util.ajax.get('/admin/filterOrgList', {
            keyWords: keyWordsOrg,
            current: paginationOrg.current,
            pageSize: paginationOrg.pageSize
        }).then(res => {
            paginationOrg.total = res.data.total
            if (paginationOrg.total > 0) {
                this.setState({
                    allOrgList: res.data.list,
                    paginationOrg,
                })
            }
        })

        const { paginationRole, keyWordsRole } = this.state

        Util.ajax.get('/admin/filterRoleList', {
            keyWords: keyWordsRole,
            current: paginationRole.current,
            pageSize: paginationRole.pageSize
        }).then(res => {
            paginationRole.total = res.data.total
            if (paginationRole.total > 0) {
                this.setState({
                    allRoleList: res.data.list,
                    paginationRole,
                })
            }
        })

    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, value) => {
            if (!err) {
                value.roleList = value.roleList.join(",")
                console.log('Received values of form: ', value);
                if (userId !== "0") {
                    Util.ajax.post('/admin/createUser', value).then(res => {
                        Util.message.success('Saved successfully')
                    })
                } else {
                    Util.ajax.post('/admin/editUser', value).then(res => {
                        Util.message.success('Saved successfully')
                    })
                }
            }
        });
    }

    handleSelectChange = (value) => {
        this.setState({ orgId: value })
    }

    handleMultiSelectChange = (value) => {
        this.setState({roleList: value.join(",")})
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form layout="horizontal" {...formItemLayout} style={{ width: '660px' }} onSubmit={this.handleOk}>
                <Form.Item label="Organization ID">
                    {getFieldDecorator('orgId', {
                        initialValue: this.state.orgId.toString(),
                        rules: [
                            { required: true, message: 'Please enter the organization', whitespace: true },
                        ],
                    })(
                        <Select onChange={this.handleSelectChange} placeholder="Please select the organization">
                            {this.state.allOrgList.map(org => (
                                <Option key={org.id} value={org.id.toString()}>{org.name}</Option>
                            ))}
                        </Select>
                    )}
                </Form.Item>

                <Form.Item label="Login Name">
                    {getFieldDecorator('loginName', {
                        initialValue: this.state.loginName,
                        rules: [
                            { required: true, message: 'Please enter the login name', whitespace: true },
                        ]
                    })(<Input />)}
                </Form.Item>
                <Form.Item label="Password">
                    {getFieldDecorator('password', {
                        initialValue: this.state.password,
                        rules: [
                            { required: true, message: 'Please enter the password', whitespace: true },
                        ]
                    })(<Input type="password" />)}
                </Form.Item>
                <Form.Item label="User Name">
                    {getFieldDecorator('userName', {
                        initialValue: this.state.userName,
                        rules: [
                            { required: true, message: 'Please enter the user name', whitespace: true },
                        ]
                    })(<Input />)}
                </Form.Item>
                <Form.Item label="Mobile">
                    {getFieldDecorator('mobile', {
                        initialValue: this.state.mobile,
                        rules: [
                            { required: true, message: 'Please enter the mobile number', whitespace: true },
                        ]
                    })(<Input />)}
                </Form.Item>
                <Form.Item label="Email">
                    {getFieldDecorator('email', {
                        initialValue: this.state.email,
                        rules: [
                            { required: true, message: 'Please enter the email', whitespace: true },
                        ]
                    })(<Input />)}
                </Form.Item>
                <Form.Item label="Remark">
                    {getFieldDecorator('remark', {
                        initialValue: this.state.remark,
                        rules: [
                            { required: true, message: 'Please enter the remark', whitespace: true },
                        ]
                    })(<Input />)}
                </Form.Item>
                <Form.Item label="Associated Roles">
                    {getFieldDecorator('roleList', {
                        initialValue: this.state.roleList ? this.state.roleList.split(',') : [],
                        rules: [
                            { required: true, message: 'Please select associated roles' },
                        ],
                    })(
                        <Select mode="multiple" onChange={this.handleMultiSelectChange} placeholder="Please select associated roles" >
                            {this.state.allRoleList.map(org => (
                                <Option key={org.id} value={org.id}>{org.rName}</Option>
                            ))}
                        </Select>
                    )}
                </Form.Item>

                <Form.Item label="" wrapperCol={{ push: 4 }}>
                    <Button className="mr20" onClick={this.handleTest}>Clear</Button>
                    <Button type="primary" onClick={this.handleSubmit}>Save</Button>
                </Form.Item>
            </Form>
        )
    }
}

const UserMgrForm = Form.create({ name: 'user-mgr-form' })(UserMgrComponent)

export default class UserMgr extends Component {

    render() {
        const isNew = userId === "0" || userId === null || userId === "null";
        return (
            <Root>
                <div className="page-content">
                    <Card title={
                        <div style={{ fontSize: '22px', fontWeight: 'bold' }}>User Management</div>
                    } bordered={false} style={{ width: '100%' }}>
                        {/* <div className="title"></div>
                        <Divider></Divider> */}
                        <div className="sub-title">
                            {isNew ? (
                                <div>Add User</div>
                            ) : (
                                <div>Edit User (id: {userId})</div>
                            )}
                        </div>
                        <Divider></Divider>
                        <UserMgrForm></UserMgrForm>
                    </Card>
                </div>
            </Root>

        )
    }
}

const Root = styled.div`
    .title{
        font-size: 22px;
        font-weight: bold;
    }
    .sub-title{
        font-size:18px;
        font-weight: bold;
        padding: 5px 0 15px;
    }
`